export default "__VITE_ASSET__BlZbOosO__"